import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);

  // Liste des services
  const services = [
    {
      id: 1,
      title: "Peinture",
      icon: "fas fa-paint-roller",
      shortDescription: "Services de peinture intérieure et extérieure avec des finitions de haute qualité pour tous types de surfaces.",
      image: "https://public.readdy.ai/ai/img_res/90bdb003737faa3e753b5261b5dfee1d.jpg",
      detailedDescription: "Notre équipe de peintres professionnels vous propose des services complets de peinture intérieure et extérieure. Nous utilisons des produits de qualité supérieure adaptés à chaque type de surface pour garantir une finition parfaite et durable.",
      features: [
        "Peinture intérieure (murs, plafonds, boiseries)",
        "Peinture extérieure (façades, murs, portails)",
        "Revêtements décoratifs et techniques",
        "Pose de papier peint et revêtements muraux",
        "Protection et traitement des surfaces",
        "Conseils en colorimétrie et décoration"
      ],
      process: [
        "Diagnostic et préparation des surfaces",
        "Protection des zones non concernées",
        "Application des sous-couches et primaires",
        "Application de la peinture en plusieurs couches",
        "Finitions et nettoyage du chantier"
      ]
    },
    {
      id: 2,
      title: "Maçonnerie",
      icon: "fas fa-hard-hat",
      shortDescription: "Travaux de maçonnerie générale, construction de murs, fondations et structures en béton armé.",
      image: "https://public.readdy.ai/ai/img_res/0bf85369f77971d7b24881f58a356b22.jpg",
      detailedDescription: "Notre expertise en maçonnerie couvre tous les aspects de la construction, de la rénovation et des travaux d'aménagement. Nous réalisons des travaux durables et conformes aux normes techniques en vigueur pour tous vos projets.",
      features: [
        "Construction et rénovation de bâtiments",
        "Élévation de murs et cloisons",
        "Création et rénovation de fondations",
        "Réalisation d'ouvertures (portes, fenêtres)",
        "Pose de carrelage et de revêtements",
        "Construction d'escaliers et de terrasses"
      ],
      process: [
        "Évaluation du projet et des besoins",
        "Établissement des plans et devis détaillés",
        "Préparation du terrain et implantation",
        "Réalisation des travaux de gros œuvre",
        "Finitions et nettoyage du chantier"
      ]
    },
    {
      id: 3,
      title: "Étanchéité",
      icon: "fas fa-tint-slash",
      shortDescription: "Solutions d'étanchéité pour toitures, terrasses et fondations, avec garantie d'efficacité et de durabilité.",
      image: "https://public.readdy.ai/ai/img_res/7a32d354b042163d7dbfbb83550c23d3.jpg",
      detailedDescription: "Nos services d'étanchéité garantissent une protection efficace contre les infiltrations d'eau pour tous types de surfaces. Nous utilisons des matériaux et des techniques modernes pour assurer une étanchéité parfaite et durable de vos toitures, terrasses et fondations.",
      features: [
        "Étanchéité de toitures plates et terrasses",
        "Étanchéité de fondations et sous-sols",
        "Traitement des fissures et infiltrations",
        "Installation de systèmes de drainage",
        "Réparation et rénovation d'étanchéité existante",
        "Solutions écologiques et durables"
      ],
      process: [
        "Diagnostic complet et identification des problèmes",
        "Préparation des surfaces à traiter",
        "Application des produits d'étanchéité adaptés",
        "Tests d'infiltration et contrôle qualité",
        "Finitions et protection des surfaces traitées"
      ]
    },
    {
      id: 4,
      title: "Électricité",
      icon: "fas fa-bolt",
      shortDescription: "Installation et mise aux normes de systèmes électriques pour résidences et locaux professionnels.",
      image: "https://public.readdy.ai/ai/img_res/653a679efcf429249f7f8631f138f39a.jpg",
      detailedDescription: "Notre équipe d'électriciens qualifiés assure l'installation, la rénovation et la mise aux normes de tous vos systèmes électriques. Nous garantissons des installations sécurisées et conformes aux normes en vigueur pour votre sécurité et votre confort.",
      features: [
        "Installation électrique complète",
        "Mise aux normes et sécurisation",
        "Dépannage et recherche de pannes",
        "Installation de tableaux électriques",
        "Éclairage intérieur et extérieur",
        "Domotique et systèmes connectés"
      ],
      process: [
        "Étude des besoins et élaboration du projet",
        "Établissement du schéma électrique",
        "Installation du matériel et câblage",
        "Tests de sécurité et mise en service",
        "Conseils d'utilisation et entretien"
      ]
    },
    {
      id: 5,
      title: "Plomberie",
      icon: "fas fa-faucet",
      shortDescription: "Installation et réparation de systèmes de plomberie, sanitaires et systèmes d'eau.",
      image: "https://public.readdy.ai/ai/img_res/d04d319a2459401a783ec6d89fcc3fed.jpg",
      detailedDescription: "Nos plombiers expérimentés prennent en charge tous vos travaux de plomberie, de l'installation à la réparation. Nous intervenons sur tous types de systèmes pour garantir une installation fonctionnelle et durable.",
      features: [
        "Installation et rénovation de plomberie",
        "Pose de sanitaires et robinetterie",
        "Réparation de fuites et dépannage urgent",
        "Installation de chauffe-eau et systèmes d'eau chaude",
        "Débouchage de canalisations",
        "Systèmes d'économie d'eau"
      ],
      process: [
        "Diagnostic des besoins ou problèmes",
        "Établissement d'un devis détaillé",
        "Réalisation des travaux de plomberie",
        "Tests de pression et vérification des installations",
        "Conseils d'entretien et garantie des travaux"
      ]
    },
    {
      id: 6,
      title: "Rénovation",
      icon: "fas fa-hammer",
      shortDescription: "Rénovation complète ou partielle de résidences et locaux commerciaux.",
      image: "https://public.readdy.ai/ai/img_res/e0156d2f8515e2dca61a58ffea6f533f.jpg",
      detailedDescription: "Nos services de rénovation couvrent tous les aspects de la transformation de votre espace, de la conception à la réalisation. Nous prenons en charge des projets de toute taille pour donner une nouvelle vie à votre intérieur ou extérieur.",
      features: [
        "Rénovation complète d'appartements et maisons",
        "Réaménagement d'espaces intérieurs",
        "Modernisation de cuisines et salles de bains",
        "Rénovation de façades et extérieurs",
        "Transformation de locaux commerciaux",
        "Finitions et décoration"
      ],
      process: [
        "Consultation et définition du projet",
        "Conception et plans de rénovation",
        "Coordination des différents corps de métier",
        "Suivi de chantier et contrôle qualité",
        "Livraison et garantie des travaux"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[500px] md:h-[600px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          role="img"
          aria-label="Image illustrant nos services professionnels en bâtiment"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/7a32d354b042163d7dbfbb83550c23d3.jpg')`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#2D2A5D]/90 to-transparent"></div>
        </div>
        <div className="container mx-auto md:px-4 h-full flex items-center relative z-10">
          <div className="w-full max-w-2xl text-white">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold mt-12 mb-3 md:mb-4">
              Nos Services Professionnels
            </h1>
            <p className="text-md md:text-lg mb-6 md:mb-8">
              Découvrez notre gamme complète de services pour tous vos projets de construction, rénovation et aménagement. Notre équipe qualifiée vous accompagne de la conception à la réalisation.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <Link
                to="/realisations"
                className="bg-red-600 hover:bg-red-700 text-white text-center px-5 py-2.5 md:px-6 md:py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap"
              >
                Voir nos réalisations
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto md:px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#2D2A5D] mb-2">Nos Services Professionnels</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Nous proposons une large gamme de services pour répondre à tous vos besoins en matière de construction, rénovation et aménagement.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div 
                key={service.id} 
                className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105 cursor-pointer"
                onClick={() => setSelectedService(service.id)}
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={`Service de ${service.title}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center mb-3">
                    <i className={`${service.icon} text-red-600 text-xl mr-3`}></i>
                    <h3 className="text-xl font-semibold text-[#2D2A5D]">{service.title}</h3>
                  </div>
                  <p className="text-gray-600 mb-4">{service.shortDescription}</p>
                  <button 
                    className="text-red-600 hover:text-red-700 font-medium flex items-center cursor-pointer whitespace-nowrap"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedService(service.id);
                    }}
                  >
                    En savoir plus <i className="fas fa-arrow-right ml-2"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Notre approche */}
      {/* <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8">
              <h2 className="text-3xl font-bold text-[#2D2A5D] mb-4">Notre Approche</h2>
              <p className="text-gray-600 mb-6">
                Chez EDMF, nous mettons un point d'honneur à offrir un service personnalisé et de qualité. Notre méthodologie de travail repose sur plusieurs principes essentiels qui font notre réputation.
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="bg-red-600 p-2 rounded-full text-white mr-4 mt-1">
                    <i className="fas fa-check"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">Évaluation personnalisée</h3>
                    <p className="text-gray-600">Nous commençons par une analyse détaillée de vos besoins pour proposer les solutions les plus adaptées.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-red-600 p-2 rounded-full text-white mr-4 mt-1">
                    <i className="fas fa-medal"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">Matériaux de qualité</h3>
                    <p className="text-gray-600">Nous utilisons exclusivement des matériaux de première qualité pour garantir la durabilité de nos interventions.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-red-600 p-2 rounded-full text-white mr-4 mt-1">
                    <i className="fas fa-clock"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">Respect des délais</h3>
                    <p className="text-gray-600">Nous nous engageons à respecter les plannings établis et à livrer votre projet dans les temps convenus.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="bg-red-600 p-2 rounded-full text-white mr-4 mt-1">
                    <i className="fas fa-shield-alt"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">Garantie des travaux</h3>
                    <p className="text-gray-600">Tous nos services sont garantis pour vous assurer une tranquillité d'esprit totale après notre intervention.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="md:w-1/2">
              <img
                src="https://public.readdy.ai/ai/img_res/660546d6e5f4379e5d0073fcf0678429.jpg"
                alt="Notre équipe"
                className="rounded-lg shadow-lg w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section> */}

      {/* Témoignages */}
      {/* <section className="py-16 bg-white">
        <div className="container mx-auto md:px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#2D2A5D] mb-2">Ce que disent nos clients</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              La satisfaction de nos clients est notre priorité. Découvrez leurs témoignages sur nos services.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg shadow-md"> */}
              {/* <div className="flex items-center mb-4">
                <div className="text-yellow-500 flex">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
                <span className="ml-2 text-gray-600">5.0</span>
              </div> */}
              {/* <p className="text-gray-700 mb-6 italic">
                "L'équipe d'EDMF a réalisé des travaux de peinture dans notre maison. La qualité du travail est impeccable et le résultat dépasse nos attentes. Nous recommandons vivement leurs services."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#2D2A5D] rounded-full flex items-center justify-center text-white font-bold">
                  AM
                </div>
                <div className="ml-4">
                  <h4 className="font-semibold text-[#2D2A5D]">Amadou Mbaye</h4>
                  <p className="text-gray-600 text-sm">Dakar, Sénégal</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow-md"> */}
              {/* <div className="flex items-center mb-4">
                <div className="text-yellow-500 flex">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                </div>
                <span className="ml-2 text-gray-600">5.0</span>
              </div> */}
              {/* <p className="text-gray-700 mb-6 italic">
                "Excellent travail d'étanchéité sur notre toiture terrasse. Professionnels, ponctuels et à l'écoute. Les infiltrations appartiennent désormais au passé. Merci EDMF !"
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#2D2A5D] rounded-full flex items-center justify-center text-white font-bold">
                  FS
                </div>
                <div className="ml-4">
                  <h4 className="font-semibold text-[#2D2A5D]">Fatou Sow</h4>
                  <p className="text-gray-600 text-sm">Rufisque, Sénégal</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow-md"> */}
              {/* <div className="flex items-center mb-4">
                <div className="text-yellow-500 flex">
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star"></i>
                  <i className="fas fa-star-half-alt"></i>
                </div>
                <span className="ml-2 text-gray-600">4.5</span>
              </div> */}
              {/* <p className="text-gray-700 mb-6 italic">
                "Nous avons fait appel à EDMF pour la rénovation complète de notre cuisine. Le résultat est magnifique et le chantier a été livré dans les temps. Une équipe vraiment compétente."
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-[#2D2A5D] rounded-full flex items-center justify-center text-white font-bold">
                  ID
                </div>
                <div className="ml-4">
                  <h4 className="font-semibold text-[#2D2A5D]">Ibrahim Diallo</h4>
                  <p className="text-gray-600 text-sm">Pikine, Sénégal</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-16 bg-[#2D2A5D]">
        <div className="container mx-auto md:px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Prêt à démarrer votre projet ?</h2>
          <p className="text-white text-lg mb-8 max-w-2xl mx-auto">
            Contactez-nous dès aujourd'hui pour discuter de vos besoins et obtenir un devis gratuit sans engagement.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/#contact"
              className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap"
            >
              Nous Contacter
            </Link>
            <Link
              to="/realisations"
              className="bg-white hover:bg-gray-100 text-[#2D2A5D] px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap"
            >
              Voir nos Réalisations
            </Link>
          </div>
        </div>
      </section>

      {/* Service Details Modal */}
      {selectedService && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center py-4 md:px-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl overflow-auto max-h-screen relative">
            <button
              onClick={() => setSelectedService(null)}
              className="absolute top-4 right-4 text-gray-500 hover:text-red-600 transition-colors cursor-pointer"
            >
              <i className="fas fa-times"></i>
            </button>
            
            {services.filter(service => service.id === selectedService).map(service => (
              <div key={service.id} className="p-8">
                <div className="flex items-center mb-6">
                  <i className={`${service.icon} text-red-600 text-2xl mr-4`}></i>
                  <h2 className="text-3xl font-bold text-[#2D2A5D]">{service.title}</h2>
                </div>
                
                <div className="mb-8">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-64 object-cover rounded-lg"
                  />
                </div>
                
                <div className="mb-6">
                  <h3 className="text-2xl font-semibold text-[#2D2A5D] mb-3">Description</h3>
                  <p className="text-gray-700">{service.detailedDescription}</p>
                </div>
                
                <div className="mb-6">
                  <h3 className="text-2xl font-semibold text-[#2D2A5D] mb-3">Ce que nous proposons</h3>
                  <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <i className="fas fa-check-circle text-green-600 mt-1 mr-2"></i>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="mb-8">
                  <h3 className="text-2xl font-semibold text-[#2D2A5D] mb-3">Notre processus</h3>
                  <ol className="border-l-2 border-[#2D2A5D] pl-6">
                    {service.process.map((step, index) => (
                      <li key={index} className="mb-4 relative">
                        <div className="absolute -left-8 bg-[#2D2A5D] text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">
                          {index + 1}
                        </div>
                        <p className="text-gray-700">{step}</p>
                      </li>
                    ))}
                  </ol>
                </div>
                
                <div className="flex justify-center mt-8">
                  <Link 
                    to="/#contact" 
                    className="bg-red-600 hover:bg-red-700 text-white px-4 md:px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap mr-4"
                  >
                    Demander un devis
                  </Link>
                  <Link
                    to="/realisations"
                    className="bg-[#2D2A5D] hover:bg-[#1F1C45] text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap"
                  >
                    Voir nos réalisations
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Call-to-Action Fixe */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 pb-6 pt-2 md:py-3 z-30">
        <div className="container mx-auto px-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
          <Link
            to="/"
            className="text-[#2D2A5D] hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base hidden sm:block"
          >
            <i className="fas fa-arrow-left mr-2"></i>Retour à l'accueil
          </Link>
          <div className="flex space-x-3 w-full sm:w-auto justify-center sm:justify-end">
            <Link
              to="/#contact"
              className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 md:px-4 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap flex-1 sm:flex-none text-center"
            >
              <i className="fas fa-phone-alt mr-1 md:mr-2"></i>Nous contacter
            </Link>
            <Link
              to="/"
              className="bg-[#2D2A5D] hover:bg-[#1F1C45] text-white px-3 py-2 md:px-4 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap flex-1 sm:flex-none text-center sm:hidden"
            >
              <i className="fas fa-home mr-1"></i>Accueil
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;